
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2041"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2041"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iKmWE", function(module, exports) {

$parcel$export(module.exports, "translations", function () { return $da5e5249960f688b$export$150b732325d14d04; });
const $da5e5249960f688b$export$150b732325d14d04 = {
    // English (en)
    en: {
        siteTitle: "Zsolt M\xe1rku",
        nav: {
            logo: "Portfolio",
            home: "Home",
            about: "About",
            skills: "Skills",
            projects: "Projects",
            contact: "Contact"
        },
        home: {
            name: "Zsolt M\xe1rku",
            hello: "Hello, It's Me",
            tagline: "And I'm a " + `<span id="typed-effect"></span>`,
            description: `Welcome to my portfolio! <br> I'm a web developer passionate about building seamless web solutions and exploring the potential of artificial intelligence.`
        },
        about: {
            title: "About " + `<span>Me</span>`,
            subtitle: "My journey and professional experiences (so far)",
            description: `I studied at the Faculty of Informatics at the University of Miskolc for two years, where I gained thorough knowledge in the field of computer science. <br>
During my studies, I discovered my passion for web development and programming, which has since defined my professional interests. <br><br>
My journey led me to the Netherlands, where I began my career at AMPCO Metal as a sawing machine operator. <br>
Within a short period, I was promoted to leadership positions, first as a Team Leader and then as a Warehouse Supervisor. <br>
In these roles, I learned how to lead teams, optimize processes, and ensure efficiency in a fast-paced industrial environment. <br><br>
Currently, I work at Arvato as a Warehouse Manager, where I oversee a larger team and supervise complex logistical operations. <br>
This role provides me with opportunities to further develop my strategic thinking and leadership skills. <br><br>
Meanwhile, my passion for IT and technology remains unchanged. <br>
I continuously expand my knowledge in web development, programming languages, as well as artificial intelligence and machine learning. <br>
This expertise enables me to combine technological innovations with my leadership experience to offer effective solutions to modern business challenges. <br><br>
I am ready to apply my knowledge and experience in new projects. <br>
Join me on this journey, and let\u{2019}s explore the endless possibilities of web development, artificial intelligence, and technological advancement together! <br>`
        },
        skills: {
            title: "My " + `<span>Skills</span>`,
            subtitle1: "Personal Skills",
            subtitle2: "Coding Skills",
            skillsData1: [
                {
                    skill: "Responsibility",
                    percentage: "95%"
                },
                {
                    skill: "Leadership",
                    percentage: "95%"
                },
                {
                    skill: "Communication",
                    percentage: "90%"
                },
                {
                    skill: "Problem solving",
                    percentage: "90%"
                },
                {
                    skill: "Critical thinking",
                    percentage: "85%"
                },
                {
                    skill: "Motivation",
                    percentage: "80%"
                },
                {
                    skill: "Teamwork",
                    percentage: "80%"
                },
                {
                    skill: "Conflict management",
                    percentage: "65%"
                }
            ],
            skillsData2: [
                {
                    skill: "HTML",
                    percentage: "90%",
                    icon: "devicon-html5-plain colored"
                },
                {
                    skill: "CSS",
                    percentage: "85%",
                    icon: "devicon-css3-plain colored"
                },
                {
                    skill: "Bootstrap",
                    percentage: "80%",
                    icon: "devicon-bootstrap-plain-wordmark colored"
                },
                {
                    skill: "Javascript",
                    percentage: "80%",
                    icon: "devicon-javascript-plain colored"
                },
                {
                    skill: "MongoDB",
                    percentage: "75%",
                    icon: "devicon-mongodb-plain-wordmark colored"
                },
                {
                    skill: "Node.JS",
                    percentage: "70%",
                    icon: "devicon-nodejs-plain-wordmark colored"
                },
                {
                    skill: "React",
                    percentage: "60%",
                    icon: "devicon-react-original colored"
                },
                {
                    skill: "Python (currently learning)",
                    percentage: "40%",
                    icon: "devicon-python-plain colored"
                }
            ]
        },
        portfolio: {
            title: "My " + `<span>Projects</span>`
        },
        contact: {
            title: "Contact " + `<span>Me</span>`,
            namePlaceholder: "Full Name",
            emailPlaceholder: "Email Address",
            mobilePlaceholder: "Mobile Number",
            subjectPlaceholder: "Email Subject",
            messagePlaceholder: "Your Message",
            submit: "Submit"
        },
        footer: {
            text: "Copyright \xa9 %YEAR% | ZsMWebDev | Zsolt M\xe1rku"
        }
    },
    // Hungarian (hu)
    hu: {
        siteTitle: "M\xe1rku Zsolt",
        nav: {
            logo: "Portf\xf3li\xf3",
            home: "F\u0151oldal",
            about: "R\xf3lam",
            skills: "K\xe9szs\xe9gek",
            projects: "Projektek",
            contact: "Kapcsolat"
        },
        home: {
            name: "M\xe1rku Zsolt",
            hello: "Hell\xf3, ez \xe9n lenn\xe9k",
            tagline: "\xc9s \xe9n egy " + `<span id="typed-effect"></span>` + " vagyok",
            description: "\xdcdv\xf6z\xf6llek a portf\xf3li\xf3mban! <br> Webfejleszt\u0151 vagyok, aki szenved\xe9llyel \xe9p\xedt felhaszn\xe1l\xf3bar\xe1t webes megold\xe1sokat, \xe9s elk\xf6telezett a mesters\xe9ges intelligencia lehet\u0151s\xe9geinek felfedez\xe9se ir\xe1nt."
        },
        about: {
            title: "R\xf6viden " + `<span>R\xf3lam</span>`,
            subtitle: "\xc9letutam \xe9s szakmai tapasztalataim (eddig)",
            description: `K\xe9t \xe9vig tanultam a Miskolci Egyetem Informatikai Kar\xe1n, ahol alapos tud\xe1st szereztem a sz\xe1m\xedt\xe1stechnika ter\xfclet\xe9n. <br>
Tanulm\xe1nyaim sor\xe1n felfedeztem szenved\xe9lyemet a webfejleszt\xe9s \xe9s a programoz\xe1s ir\xe1nt, amely az\xf3ta is meghat\xe1rozza szakmai \xe9rdekl\u{151}d\xe9semet. <br><br>
Az utam Hollandi\xe1ba vezetett, ahol az AMPCO Metal- n\xe1l kezdtem karrieremet f\u{171}r\xe9szg\xe9p- kezel\u{151}k\xe9nt. <br>
R\xf6vid id\u{151}n bel\xfcl vezet\u{151}i poz\xedci\xf3kba l\xe9ptem el\u{151}, el\u{151}sz\xf6r Team Leader, majd Warehouse Supervisor szerepben. <br>
Ezekben a poz\xedci\xf3kban megtanultam, hogyan ir\xe1ny\xedtsak csapatokat, optimaliz\xe1ljam a folyamatokat, \xe9s biztos\xedtsam a hat\xe9konys\xe1got egy gyors temp\xf3j\xfa ipari k\xf6rnyezetben. <br><br>
Jelenleg az Arvat\xf3n\xe1l dolgozom, mint Warehouse Manager, ahol egy nagyobb csapat ir\xe1ny\xedt\xe1s\xe1val \xe9s komplex logisztikai m\u{171}veletek fel\xfcgyelet\xe9vel foglalkozom. <br>
Ez a szerep lehet\u{151}s\xe9get ny\xfajt sz\xe1momra, hogy tov\xe1bb fejlesszem strat\xe9giai gondolkod\xe1somat \xe9s vezet\u{151}i k\xe9pess\xe9geimet. <br><br>
Mindek\xf6zben az informatika \xe9s a technol\xf3gia ir\xe1nti szenved\xe9lyem v\xe1ltozatlan maradt. <br>
Folyamatosan b\u{151}v\xedtem tud\xe1somat a webfejleszt\xe9s, a programoz\xe1si nyelvek, valamint a mesters\xe9ges intelligencia \xe9s g\xe9pi tanul\xe1s ter\xfclet\xe9n. <br>
Ez a tud\xe1s lehet\u{151}v\xe9 teszi sz\xe1momra, hogy \xf6tv\xf6zzem a technol\xf3giai innov\xe1ci\xf3kat a vezet\u{151}i tapasztalataimmal, \xe9s hat\xe9kony megold\xe1sokat k\xedn\xe1ljak a modern \xfczleti kih\xedv\xe1sokra. <br><br>
K\xe9szen \xe1llok arra, hogy tud\xe1somat \xe9s tapasztalataimat \xfaj projektekben kamatoztassam. <br>
Csatlakozz hozz\xe1m ezen az \xfaton, \xe9s fedezz\xfck fel egy\xfctt a webfejleszt\xe9s, a mesters\xe9ges intelligencia \xe9s a technol\xf3giai fejl\u{151}d\xe9s v\xe9gtelen lehet\u{151}s\xe9geit! <br>`
        },
        skills: {
            title: "Saj\xe1t " + `<span>K\xe9pess\xe9geim \xe9s K\xe9szs\xe9geim</span>`,
            subtitle1: "Saj\xe1t K\xe9pess\xe9geim",
            subtitle2: "Saj\xe1t K\xe9szs\xe9geim",
            skillsData1: [
                {
                    skill: "Felel\u0151ss\xe9g",
                    percentage: "95%"
                },
                {
                    skill: "Vezet\u0151i k\xe9pess\xe9gek",
                    percentage: "95%"
                },
                {
                    skill: "Kommunik\xe1ci\xf3",
                    percentage: "90%"
                },
                {
                    skill: "Probl\xe9mamegold\xe1s",
                    percentage: "90%"
                },
                {
                    skill: "Kritikus gondolkod\xe1s",
                    percentage: "85%"
                },
                {
                    skill: "Motiv\xe1ci\xf3",
                    percentage: "80%"
                },
                {
                    skill: "Csapatmunka",
                    percentage: "80%"
                },
                {
                    skill: "Konfliktuskezel\xe9s",
                    percentage: "65%"
                }
            ],
            skillsData2: [
                {
                    skill: "HTML",
                    percentage: "90%",
                    icon: "devicon-html5-plain colored"
                },
                {
                    skill: "CSS",
                    percentage: "85%",
                    icon: "devicon-css3-plain colored"
                },
                {
                    skill: "Bootstrap",
                    percentage: "80%",
                    icon: "devicon-bootstrap-plain-wordmark colored"
                },
                {
                    skill: "Javascript",
                    percentage: "80%",
                    icon: "devicon-javascript-plain colored"
                },
                {
                    skill: "MongoDB",
                    percentage: "75%",
                    icon: "devicon-mongodb-plain-wordmark colored"
                },
                {
                    skill: "Node.JS",
                    percentage: "70%",
                    icon: "devicon-nodejs-plain-wordmark colored"
                },
                {
                    skill: "React",
                    percentage: "60%",
                    icon: "devicon-react-original colored"
                },
                {
                    skill: "Python (jelenleg tanulom)",
                    percentage: "40%",
                    icon: "devicon-python-plain colored"
                }
            ]
        },
        portfolio: {
            title: "Saj\xe1t " + `<span>Projektjeim</span>`
        },
        contact: {
            title: "Keress " + `<span>Meg</span>`,
            namePlaceholder: "Teljes n\xe9v",
            emailPlaceholder: "Email c\xedm",
            mobilePlaceholder: "Telefonsz\xe1m",
            subjectPlaceholder: "Email t\xe1rgya",
            messagePlaceholder: "\xdczeneted",
            submit: "K\xfcld\xe9s"
        },
        footer: {
            text: "Szerz\u0151i jog \xa9 %YEAR% | ZsMWebDev | M\xe1rku Zsolt"
        }
    },
    // Dutch (nl)
    nl: {
        siteTitle: "Zsolt M\xe1rku",
        nav: {
            logo: "Portfolio",
            home: "Home",
            about: "Over Mij",
            skills: "Vaardigheden",
            projects: "Projecten",
            contact: "Contact"
        },
        home: {
            name: "Zsolt M\xe1rku",
            hello: "Hallo, Ik ben het",
            tagline: "En ik ben een " + `<span id="typed-effect"></span>`,
            description: `Welkom op mijn portfolio! <br> Ik ben een webontwikkelaar met een passie voor het bouwen van gebruiksvriendelijke weboplossingen en het verkennen van de mogelijkheden van kunstmatige intelligentie.`
        },
        about: {
            title: "Over " + `<span>Mij</span>`,
            subtitle: "Mijn levenspad en professionele ervaringen (tot nu toe)",
            description: `Ik heb twee jaar gestudeerd aan de Faculteit Informatica van de Universiteit van Miskolc, waar ik grondige kennis heb opgedaan op het gebied van computerwetenschappen. <br>
Tijdens mijn studie ontdekte ik mijn passie voor webontwikkeling en programmeren, wat sindsdien mijn professionele interesse heeft bepaald. <br><br>
Mijn reis bracht me naar Nederland, waar ik mijn carri\xe8re begon bij AMPCO Metal als zaagmachine-operator. <br>
Binnen korte tijd werd ik gepromoveerd naar leidinggevende functies, eerst als Teamleider en daarna als Magazijnsupervisor. <br>
In deze rollen leerde ik hoe ik teams moet leiden, processen kan optimaliseren en effici\xebntie kan waarborgen in een snel veranderende industri\xeble omgeving. <br><br>
Momenteel werk ik bij Arvato als Magazijnmanager, waar ik een groter team aanstuur en complexe logistieke operaties overzie. <br>
Deze rol biedt mij de mogelijkheid om mijn strategisch denkvermogen en leiderschapsvaardigheden verder te ontwikkelen. <br><br>
Ondertussen is mijn passie voor IT en technologie onveranderd gebleven. <br>
Ik breid voortdurend mijn kennis uit op het gebied van webontwikkeling, programmeertalen, evenals kunstmatige intelligentie en machine learning. <br>
Deze expertise stelt mij in staat om technologische innovaties te combineren met mijn leidinggevende ervaring en effectieve oplossingen te bieden voor moderne zakelijke uitdagingen. <br><br>
Ik ben klaar om mijn kennis en ervaring in nieuwe projecten toe te passen. <br>
Sluit je aan bij mijn reis en laten we samen de eindeloze mogelijkheden van webontwikkeling, kunstmatige intelligentie en technologische vooruitgang ontdekken! <br>`
        },
        skills: {
            title: "Mijn " + `<span>Competenties en Vaardigheden</span>`,
            subtitle1: "Mijn Competenties",
            subtitle2: "Mijn Vaardigheden",
            skillsData1: [
                {
                    skill: "Verantwoordelijkheid",
                    percentage: "95%"
                },
                {
                    skill: "Leiderschap",
                    percentage: "95%"
                },
                {
                    skill: "Communicatie",
                    percentage: "90%"
                },
                {
                    skill: "Probleemoplossend vermogen",
                    percentage: "90%"
                },
                {
                    skill: "Kritisch denken",
                    percentage: "85%"
                },
                {
                    skill: "Motivatie",
                    percentage: "80%"
                },
                {
                    skill: "Teamwerk",
                    percentage: "80%"
                },
                {
                    skill: "Conflictbeheer",
                    percentage: "65%"
                }
            ],
            skillsData2: [
                {
                    skill: "HTML",
                    percentage: "90%",
                    icon: "devicon-html5-plain colored"
                },
                {
                    skill: "CSS",
                    percentage: "85%",
                    icon: "devicon-css3-plain colored"
                },
                {
                    skill: "Bootstrap",
                    percentage: "80%",
                    icon: "devicon-bootstrap-plain-wordmark colored"
                },
                {
                    skill: "Javascript",
                    percentage: "80%",
                    icon: "devicon-javascript-plain colored"
                },
                {
                    skill: "MongoDB",
                    percentage: "75%",
                    icon: "devicon-mongodb-plain-wordmark colored"
                },
                {
                    skill: "Node.JS",
                    percentage: "70%",
                    icon: "devicon-nodejs-plain-wordmark colored"
                },
                {
                    skill: "React",
                    percentage: "60%",
                    icon: "devicon-react-original colored"
                },
                {
                    skill: "Python (momenteel aan het leren)",
                    percentage: "40%",
                    icon: "devicon-python-plain colored"
                }
            ]
        },
        portfolio: {
            title: "Mijn " + `<span>Projecten</span>`
        },
        contact: {
            title: "Contact " + `<span>Mij</span>`,
            namePlaceholder: "Volledige naam",
            emailPlaceholder: "E-mailadres",
            mobilePlaceholder: "Telefoonnummer",
            subjectPlaceholder: "Onderwerp van de e-mail",
            messagePlaceholder: "Uw bericht",
            submit: "Verzenden"
        },
        footer: {
            text: "Auteursrecht \xa9 %YEAR% | ZsMWebDev | Zsolt M\xe1rku"
        }
    }
};

});


parcelRequire("iKmWE");

//# sourceMappingURL=portfolio.e6a32075.js.map
